import * as React from 'react';
import Modal from '@material-ui/core/Modal';

const CustomModal = React.forwardRef((props, ref) => {
    return <Modal ref={ref} {...props} />;
});

export { CustomModal as Modal };
